const productSliderV1Override = function (slider) {
  const sliderWrapEl = slider.closest('.product-slider-sec')
  const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
  const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
  const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

  // Default slider options  - boxed, 3 slides
  const optionDefault = {

    spaceBetween: 40,
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 768px
      767: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    },
    pagination: {
      el: swiperPagination,
      clickable: true,
      dynamicBullets: false,
    },
    navigation: {
      nextEl: swiperButtonNext,
      prevEl: swiperButtonPrev,
    },
  }

  // Slider options use on Doritos - full width, 6 slides
  const optionDoritos = {
    spaceBetween: 40,
    slidesPerView: 2,
    centeredSlides: true,
    loop: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 768px
      767: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 6,
        spaceBetween: 40
      }
    },
    pagination: {
      el: swiperPagination,
      clickable: true,
      dynamicBullets: false,
    },
    navigation: {
      nextEl: swiperButtonNext,
      prevEl: swiperButtonPrev,
    },
  }
  return optionDefault

}
window.productSliderV1Override = productSliderV1Override

